import React, { useEffect, useMemo, useState } from "react";
import "./GroupList.css";
import { Edit, Trash } from "lucide-react";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

const GroupList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const rowsPerPage = 5;
  
  // const { profile } = useSelector((state) => state.userProfile);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(fetchAdminProfile());
  // }, [dispatch]);
  //  console.log("profile data" ,profile);


  // Dynamic State Data
  const [groups, setGroups] = useState([
    { id: 1, group: "Group A", type: "FD", status: "Active" },
    { id: 2, group: "Group B", type: "RD", status: "Inactive" },
    { id: 3, group: "Premium FD", type: "FD", status: "Active" },
  ]);
  



  const superAdminId = localStorage.getItem("adminuserId")|| 14;

  const fetchGroups = async () => {
    
    console.log(superAdminId);
    try {
      const res = await axios.get(
        `https://payyug.in/api/ledger-group/get-all?superAdminId=${superAdminId}`
      );

      console.log("response data", res);
      setGroups(res.data.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

    useEffect(()=> {
    fetchGroups();
  },[]);



  // Form Data
  const [formData, setFormData] = useState({
    name:"",
    type: "",
    status: "",
  });

  // Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Create/Update Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.group || !formData.type || !formData.status) {
      alert("Please fill all fields");
      return;
    }

    if (editIndex !== null) {
      const updated = [...groups];
      updated[editIndex] = { ...updated[editIndex], ...formData };
      setGroups(updated);
      setEditIndex(null);
    } else {
      setGroups([
        ...groups,
        { id: groups.length + 1, ...formData },
      ]);
    }

    setFormData({ name: "", type: "", status: "" });
    setModalOpen(false);
  };

  // Edit Handler
  // const handleEdit = (index) => {
  //   setEditIndex(index);
  //   setFormData(groups[index]);
  //   setModalOpen(true);
  // };

  const handleEdit = (item) => {
  setEditIndex(item.id);

  const row = item;
  setFormData({
    name: row.name,
    type: row.type,
    status: row.status === 1 ? "Active" : "Inactive"
  });

  setModalOpen(true);
};

  const createUpdate = async (e) => {
    e.preventDefault();
    console.log("formdata values are",formData);
    var payload = {
      name: formData.name,
      head_id: 1,
      superAdminId: superAdminId,
      createdBy: localStorage.getItem("userid"),
      staffId: 4,
      type: formData.type,
      branchId: 1,
      status: formData.status === "Active" ? 1 : 0
    }

    try {
      if (editIndex !== null) {
        // ===================== UPDATE ======================
        await axios.put(`https://payyug.in/api/ledger-group/update/${editIndex}`, payload);
        toast.success("Center updated successfully");
      } else {
        // ===================== CREATE ======================
        await axios.post(`https://payyug.in/api/ledger-group/create`, payload);

        toast.success("Center created successfully");
      }

      fetchGroups();
      setModalOpen(false);
    } catch (error) {
      console.log("API Error:", error);
      toast.error(error?.response?.data?.error || "Failed to save");
    }
  };

   const handledelete = (id) => async () => {
      const confirmDelete = window.confirm("Are you sure you want to delete this center?");
      if (!confirmDelete) return;

      try {
        await axios.delete(`https://payyug.in/api//ledger-group/delete/${id}`);
        toast.success("Center deleted successfully");
        fetchGroups();
      } catch (error) {
        toast.error("Failed to delete center");
      }
    };

  // Search + Pagination
  const filteredData = useMemo(() => {
    let data = [...groups];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    // if (searchQuery.trim()) {
    //   data = data.filter((item) =>
    // item.group.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.status.toLowerCase().includes(searchQuery.toLowerCase())
    //   );
    // }

    return data;
  }, [groups, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      <div className="account-group-list-container">
        <h2 className="heading">Group List</h2>

        <div className="account-group-list-top-section">
          <input
            type="text"
            placeholder="Search by Group / Type / Status..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <button
            className="add-btn"
            onClick={() => {
              setFormData({ group: "", type: "", status: "" });
              setEditIndex(null);
              setModalOpen(true);
            }}
          >
            Add New
          </button>
        </div>

        {/* Table */}
        <div className="account-group-list-report-section">
          <table className="account-group-list-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Group Name</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.type}</td>
                    <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                    <td className="group-list-action-buttons">
                      <button
                      className="edit-icon-gl"
                        onClick={() =>
                          handleEdit(item)
                        }
                      >
                        <Edit size={18} />
                      </button>
                      <Trash className="delete-icon-gl" onClick={handledelete(item.id)}> </Trash>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

         {/* Pagination */}
         <div className="account-group-list-pagination-section">
          {filteredData.length > rowsPerPage && (
            <div className="account-group-list-pagination-div">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
          )}
         </div>
          

        {/* Modal */}
        {modalOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2 className="dialog-box-heading">
                {editIndex !== null ? "Edit Group" : "Add New Group"}
              </h2>

              <form className="dialog-box-form-section" onSubmit={createUpdate}>
                <div className="dialog-box-input-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="dialog-box-input-group">
                  <label>Status</label>
                  <select name="status" value={formData.status} onChange={handleChange}>
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>

                <div className="dialog-box-input-group">
                  <label>Type</label>
                  <select name="type" value={formData.type} onChange={handleChange}>
                    <option value="">Select Type</option>
                    <option value="FD">FD</option>
                    <option value="RD">RD</option>
                    {/* <option value=""></option> */}
                  </select>
                </div>

                <div className="dialog-btns">
                  <button type="submit">
                    {editIndex !== null ? "Update" : "Create"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default GroupList;
